// src/components/PrivateRoute.js
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, token } = useAuth();
  const storedToken = localStorage.getItem('token');
  
  return (user || token || storedToken) ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
